import { Box, Flex, Heading, Spinner, Text, useToast } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import { AddIcon } from '@chakra-ui/icons';
import CustomTable from '../../../../components/customTable/customTable';
import CustomDrawer from '../../../../components/customDrawer/customDrawer';
import PrimaryButton from '../../../../components/primaryButton/primarybutton';
import CustomInput from '../../../../components/customInput/customInput';
import CustomSelect from '../../../../components/customSelect/customSelect';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../../../services/api';
import EmptyState from '../../../../components/emptyState/emptyState';
import { BiDotsVerticalRounded } from 'react-icons/bi'
import { useSelector } from 'react-redux';

const StoreInventory = ({data}) => {
  const [loading, setLoading] = useState(false);
  const [loadingx, setLoadingx] = useState(false);
  const [loadingd, setLoadingd] = useState(false);
  const [brand, setBrand] = useState('');
  const [sku, setSku] = useState('');
  const [cases, setCases] = useState('');
  const [availableStockQty, setAvailableStockQty] = useState('');
  const [date, setDate] = useState('');
  const [filterDate, setFilterDate] = useState('');

  const currentUser = useSelector(({userData})=>  userData?.currentUser);

  const [idx, setIdx] = useState({
    one: '',
    two: '',
    three: '',
    four: '',
    id: ''
  })

  const [brandx, setBrandx] = useState(idx?.two);
  const [skux, setSkux] = useState(idx?.three);

  const [triggerClose, setTriggerClose] = useState("");

  const state = useLocation()
  const id = state?.pathname?.split('/')[1]
  const [docs, setDocs] = useState([])
  const [refetch, setRefetch] = useState('')
  const toast = useToast()

    const getDocs = async() => {
        setLoading(true)
        try {
            const res = await axiosInstance.get(filterDate ? `/store-inventories?initiativeStoreId=${id}&date=${filterDate}` : `/store-inventories?initiativeStoreaId=${id}`)
            setDocs(res?.data?.data)
        } catch(error) {
            console.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getDocs()
    }, [refetch, filterDate])

  const tHeaders = [ 'Brand', 'SKU', 'Stock', "Cases"]

  const tData = docs?.map(i => ({
    // one: i?.date?.slice(0, 10),
    one: i?.brandName,
    two: i?.sku,
    three: i?.availableStockQty,
    four: i?.totalCase,
    id: i?._id,
  }))

  const options1 = data?.initiative?.brands?.map(i => ({
    title: i?.name,
    value: i?.name
  }))

  const options2 = data?.initiative?.brands?.filter(i => i?.name === brand)?.map(i => ({
    title: i?.sku,
    value: i?.sku
  }))
  const selectedBrand = data?.initiative?.brands?.find(i => i?.name === brand)

  const addInventory = async () => {
    setTriggerClose("");
    setLoadingx(true);
    const datax = {
      brandName: brand,
      sku: sku,
      units: parseInt(availableStockQty),
      cases: parseInt(cases),
      state: data?.store?.state,
      // caseUnitsNumber: selectedBrand?.caseUnitsNumber,
      // pricePerCase: selectedBrand?.pricePerCase
    };
    try {
      const res = await axiosInstance.post(
        `initiative-stores/${id}/store-inventories`,
        datax
      );
      toast({
        description: res?.data?.message,
        status: "success",
        position: "top",
      });
      setTriggerClose("close");
      setRefetch(Math.random());
    } catch (error) {
      toast({
        title: "An Error Occurred",
        description: error?.response?.data?.message,
        status: "error",
        position: "top",
      });
    } finally {
      setLoadingx(false);
    }
  };

  const editInventory = async () => {
    setTriggerClose("");
    setLoadingx(true);
    const datax = {
      brandName: idx?.one,
      sku: idx?.two,
      availableStockQty: parseInt(idx?.three),
      cases: parseInt(cases),
      state: data?.store?.state,
      // caseUnitsNumber: data?.initiative?.brands?.find(i => i?.name === idx?.two)?.caseUnitsNumber,
      // pricePerCase: data?.initiative?.brands?.find(i => i?.name === idx?.two)?.pricePerCase
    };
    try {
      const res = await axiosInstance.patch(
        `store-inventories/${idx?.id}`,
        datax
      );
      toast({
        description: res?.data?.message,
        status: "success",
        position: "top",
      });
      setTriggerClose("close");
      setRefetch(Math.random());
    } catch (error) {
      toast({
        title: "An Error Occurred",
        description: error?.response?.data?.message,
        status: "error",
        position: "top",
      });
    } finally {
      setLoadingx(false);
    }
  };

  const uniqueBrandsList = options1?.filter((item, index, array) => {
    return (
      index === array.findIndex(obj => obj.title === item.title && obj.value === item.value)
    );
  });

  const deleteDoc = async(id) => {
    setLoadingd(true)
    try {
      const {data} = await axiosInstance.delete(`/store-inventories/${id}`)
      toast({
        description: data?.message,
        status: "success",
        position: "top",
      });
      setTriggerClose("close");
      setRefetch(Math.random());
    } catch (error) {
      toast({
        title: "An Error Occurred",
        description: error?.response?.data?.message,
        status: "error",
        position: "top",
      });
    } finally {
      setLoadingd(false)
    }
  }



  return (
    <Box>
        <Flex mt="1rem" mb="1.2rem" alignItems={"center"} justifyContent={"space-between"}>
            <Heading fontWeight={500} fontSize="1.1rem" color="#475467" fontFamily='Roboto'>Store Inventory</Heading>
            {currentUser?.role === "Promoter" && <CustomDrawer 
              position={"bottom"} 
              title={"Add store inventory"} 
              triggerClose={triggerClose}
              toggleElement={
                <Text fontSize={"12px"} padding={".4rem .5rem"} cursor={"pointer"} color={"#667085"} fontWeight={"600"} border=".8px solid #D0D5DD" borderRadius={"8px"}>Add Store Inventory<AddIcon transform={"translateY(-1px) scale(.9)"} ml=".3rem" /></Text>
              }
              content={
                <>
                  <CustomSelect 
                  placeholder={"Brand"}
                  selection={brand}
                  setSelection={setBrand}
                  options={uniqueBrandsList}
                  mb=".8rem"
                  />
                  <CustomSelect 
                  placeholder={"SKU"}
                  selection={sku}
                  setSelection={setSku}
                  options={options2}
                  mb=".8rem"
                  />
                  <Text mb=".5rem">Available Stock</Text>
                  <Flex gap="1rem" alignItems={"center"}>
                  <CustomInput
                  type={"tel"}
                  required
                  placeholder={"Units"}
                  mb={".8rem"}
                  onChange={e => setAvailableStockQty(parseInt(e.target.value))}
                  />
                  <CustomInput
                  type={"tel"}
                  required
                  placeholder={"Cases"}
                  mb={".8rem"}
                  onChange={e => setCases(parseInt(e.target.value))}
                  />
                  </Flex>
                  <Box padding=".4rem" borderRadius={"4px"} bg={"#E0E0E0"} mb=".8rem">
                    <Text fontWeight={"700"} fontSize={".9rem"}>Note</Text>
                    <Text fontWeight={"500"} fontSize={".85rem"}>1. If you sold only units, add in under UNITS only</Text>
                    <Text fontWeight={"500"} fontSize={".85rem"}>2. If you sold only cases/cartons, add under CASES only</Text>
                    <Text fontWeight={"500"} fontSize={".85rem"}>3. If you sold both cases/carton and some extra units (add the cases amount and units amount under cases and units respectively)</Text>
                  </Box>
          
                  {/* <CustomInput
                  type={"date"}
                  required
                  placeholder={"Date"}
                  mb={".8rem"}
                  onChange={e => setDate(e.target.value)}
                  /> */}
                  <PrimaryButton mt="2rem" onClick={addInventory} text="Save item" loading={loadingx} />
                </>
              }
            />}
        </Flex>

        {/* <Flex mb="1.2rem" alignItems={"center"} justifyContent={"flex-end"}>
        <Flex gap="1rem" alignItems={"center"}>
            {filterDate !== "" && <Text onClick={() => setFilterDate("")} fontSize={".9rem"} cursor={"pointer"} fontWeight={"500"} color="#7F56D9">Show all dates</Text>}
            <Box width={"150px"}>
                <CustomInput
                type={"date"}
                required
                placeholder={"Select Date"}
                value={filterDate}
                onChange={e => setFilterDate(e.target.value)}
                mt="0"
                py="1rem"
                borderColor="lightgray"
                fontSize=".8rem"
                />
            </Box>
        </Flex>
        </Flex> */}


        <CustomTable 
        headers={tHeaders}
        type={"inventory"}
        data={tData}
        setIdx={setIdx}
        triggerClose={triggerClose}
        manage={
          <>
            <Flex mb=".5rem" justifyContent={"flex-end"}>
              {loadingd ?
              <Spinner size="xs" />
              :
                <Text onClick={() => deleteDoc(idx?.id)} fontSize={".9rem"} cursor={"pointer"} textDecoration={"underline"} fontWeight={"500"} color={"crimson"}>Delete</Text>}
            </Flex>
            <CustomSelect 
            placeholder={"Brand"}
            selection={brand}
            setSelection={setBrandx}
            options={uniqueBrandsList}
            mb=".8rem"
            value={idx?.one}
            />
            <CustomSelect 
            placeholder={"SKU"}
            selection={sku}
            setSelection={setSkux}
            options={options2}
            mb=".8rem"
            value={idx?.two}
            />
            <CustomInput
            type={"tel"}
            required
            placeholder={"Available Stock"}
            mb={".8rem"}
            onChange={e => setIdx({...idx, three: e.target.value})}
            value={idx?.three}
            />
            <Box padding=".4rem" borderRadius={"4px"} bg={"#E0E0E0"} mb=".8rem">
                    <Text fontWeight={"700"} fontSize={".9rem"}>Note</Text>
                    <Text fontWeight={"500"} fontSize={".85rem"}>1. If you sold only units, add in under UNITS only</Text>
                    <Text fontWeight={"500"} fontSize={".85rem"}>2. If you sold only cases/cartons, add under CASES only</Text>
                    <Text fontWeight={"500"} fontSize={".85rem"}>3. If you sold both cases/carton and some extra units (add the cases amount and units amount under cases and units respectively)</Text>
                  </Box>
            {/* <CustomInput
            type={"date"}
            required
            placeholder={"Date"}
            mb={".8rem"}
            onChange={e => setIdx({...idx, one: e.target.value})}
            value={idx?.one}
            /> */}
            <PrimaryButton mt="2rem" onClick={editInventory} text="Update item" loading={loadingx} />
          </>
        }
        />
        {docs?.length < 1 && <EmptyState text={"No Inventories added yet."} />}
        {/* <Box mt="1.2rem" borderRadius={"8px"} height={"385px"} backgroundSize={"cover"} backgroundImage={Temp} borderBottom=".6px solid #98A2B3" /> */}
    </Box>
  )
}

export default StoreInventory;